import {CommonModalTemplatesEnum} from './all-modals-config';
import {ModalInformationAndActionDataInterface} from './modal-information-and-action-component/modal-information-and-action-data.interface';
import {CommonModalService} from '../common-modal/common-modal.service';
import {AppInjector} from '../../utils/appInjector/setAppInjector';
import {IconsEnum} from '../../utils/icons.enum';
import {ModalStatementInterface} from "./modal-statement/modal-statement.interface";
import {ModalAsmExpireInterface} from "./modal-asm-expire/modal-asm-expire.interface";
import {ModalConfirmInterface} from "./modal-confirm/modal-confirm.interface";
import {ModalCancelOrderInterface} from "./modal-cancel-order/modal-cancel-order.interface";
import {ModalCancelSubscriptionInterface} from "./modal-cancel-subscription/modal-cancel-subscription.interface";

export class CpConfigWarningModalStatic implements ModalInformationAndActionDataInterface {
  constructor(
    public _data: ModalInformationAndActionDataInterface
  ) {
    this.submitBtnText = (_data && _data.submitBtnText) || this.submitBtnText;
    this.message = (_data && _data.message) || this.message;
  }

  private commonModalService: CommonModalService = AppInjector.get(CommonModalService);

  public templateName: CommonModalTemplatesEnum = CommonModalTemplatesEnum.INFO_ADN_ACTION;

  public headerText = 'complete.pair.warning.modal.header.text';
  public showIcon = true;
  public message = '';
  public submitBtnText = 'ok.confirmation';
  public submitBtn: Function = () => {
    this.commonModalService.closeAllModals();
  }
}

export class CancelOrderModalStatic implements ModalCancelOrderInterface {
  constructor(
    public _data: ModalCancelOrderInterface
  ) {
    this.cancelOrderUrl = _data.cancelOrderUrl || null;
    this.cancelReasons = _data.cancelReasons || null;
    this.cancelReasonsForm = _data.cancelReasonsForm || null;
  }

  private commonModalService: CommonModalService = AppInjector.get(CommonModalService);

  public templateName: CommonModalTemplatesEnum = CommonModalTemplatesEnum.CANCEL_ORDER;

  public cancelOrderUrl: string;
  public headerText = 'cancel.order.confirmation.text';
  public submitBtnText = 'cancel.order.yes.text';
  public cancelReasons;
  public cancelReasonsForm;

  public showIcon = false;
  public showCloseBtn = false;
  public iconClassName = IconsEnum.APPLICATION;

  public hidePopupBtnText = 'cancel.order.no.text';
  public hidePopupBtn: Function = () => {
    this.commonModalService.closeAllModals();
    this.commonModalService.destroyAllModals();
  }
}

export class CancelSubscriptionModalStatic implements ModalCancelSubscriptionInterface {
  constructor(
    public _data: ModalCancelSubscriptionInterface
  ) {
    this.cancelReasons = _data.cancelReasons || null;
    this.cancelReasonsForm = _data.cancelReasonsForm || null;
  }

  private commonModalService: CommonModalService = AppInjector.get(CommonModalService);

  public templateName: CommonModalTemplatesEnum = CommonModalTemplatesEnum.CANCEL_SUBSCRIPTION;

  public headerText = 'cancel.order.confirmation.text';
  public submitBtnText = 'cancel.order.yes.text';
  public cancelReasons;
  public cancelReasonsForm;

  public showIcon = false;
  public showCloseBtn = false;
  public iconClassName = IconsEnum.APPLICATION;

  public hidePopupBtnText = 'cancel.order.no.text';
  public hidePopupBtn: Function = () => {
    this.commonModalService.closeAllModals();
    this.commonModalService.destroyAllModals();
  }
}

export class NipErrorModalStatic implements ModalStatementInterface{
  constructor(
    public _data: ModalStatementInterface
  ) {
    this.message = (_data && _data.message) || this.message;
  }

  private commonModalService: CommonModalService = AppInjector.get(CommonModalService);

  public templateName: CommonModalTemplatesEnum = CommonModalTemplatesEnum.STATEMENT;
  public headerText = '';
  public submitBtnText = 'modal.nip.error.button.text';
  public message: string;

  public submitBtn: Function = () => {
    this.commonModalService.closeAllModals();
  }
}

export class AsmExpireModalStatic implements ModalAsmExpireInterface {
  constructor(
    public _data: ModalAsmExpireInterface
  ) {
    typeof(_data.counter) !== 'undefined' ? this.counter = _data.counter : null;
    typeof(_data.agentTimer) !== 'undefined' ? this.agentTimer = _data.agentTimer : null;
  }

  private commonModalService: CommonModalService = AppInjector.get(CommonModalService);

  public templateName: CommonModalTemplatesEnum = CommonModalTemplatesEnum.ASM_EXPIRE;
  public showCloseBtn = false;
  public disableClose = true;
  public counter: number;
  public agentTimer: number;

  public resetSession: Function = () => {
    this.commonModalService.closeAllModals();
    this.commonModalService.destroyAllModals();
  }
}

export class ConfirmModalStatic implements ModalConfirmInterface {
  constructor(
    public _data: ModalConfirmInterface
  ) {
    this.submitForm = _data?.submitForm || null;
    this.headerText = _data?.headerText || '';
    this.runFunc = _data?.runFunc || null;
    this.modalClass = _data?.modalClass;
    this.submitBtnText = _data?.submitBtnText || 'cancel.subscription.yes.text';
    this.hidePopupBtnText = _data.hidePopupBtnText || 'cancel.order.no.text';
    this.showCloseBtn = _data?.showCloseBtn || false;
  }

  private commonModalService: CommonModalService = AppInjector.get(CommonModalService);

  public templateName: CommonModalTemplatesEnum = CommonModalTemplatesEnum.INFO_AND_CONFIRM;

  public headerText = '';
  public submitBtnText = 'cancel.subscription.yes.text';
  public hidePopupBtnText = 'cancel.order.no.text';
  public submitForm = null;
  public runFunc = null;
  public showIcon = false;
  public showCloseBtn = false;
  public iconClassName = IconsEnum.APPLICATION;
  public modalClass = '';

  public submitBtn: Function = () => {
    this.submitForm && this.submitForm.submit();
    this.runFunc && this.runFunction(this.runFunc.name, this.runFunc.arg)
  };

  public hidePopupBtn: Function = () => {
    this.commonModalService.closeAllModals();
  }

  private runFunction(_fn, _arg = ''): void {
    const fn = _fn;
    const arg = _arg;

    fn(arg);
  }
}
